import React from 'react'
import FunnelBuilder from './FunnelBuilder'

const EditFunnel = () => {
    return (
        <FunnelBuilder isEdit={true} />
    )
}

export default EditFunnel